"use strict";import{ActionButton as t}from"./src/ActionButton.js";import{defineElement as o}from"@spectrum-web-components/base/src/define-element.js";o("sp-action-button",t);
//# sourceMappingURL=sp-action-button.js.map
